import React from 'react';
import PropTypes from 'prop-types';

import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import PopupTable from '@appComponents/PopupTable';
import {CLIENT} from '@constants/resources';
import {SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';
import {TunnelStatus} from '@utils/tableHelpers';

const renderClient = (clientId, clientName) => {
    if (!clientId) {
        return clientName ?? '-';
    }

    return (
        <LinkWithAuthorization
            link={{
                name: 'clients.edit',
                params: {id: clientId},
            }}
            newWindow={true}
            authorization={{
                [CLIENT]: SECURITY_PRIVILEGES_UPDATE,
            }}
        >
            {clientName ?? `Client (${clientId})`}
        </LinkWithAuthorization>
    );
};

const renderConfigurationLink = (clientId, thirdPartyClientTunnelId) => (
    <LinkWithAuthorization
        link={{
            name: 'clients.products.thirdParty.tunnels.edit',
            params: {
                id: clientId,
                thirdPartyClientTunnelId,
            },
        }}
        newWindow={true}
        authorization={{
            [CLIENT]: SECURITY_PRIVILEGES_UPDATE,
        }}
    >
        Configuration
    </LinkWithAuthorization>
);

export const OutputTunnelPopupTable = ({
    vtdTunnelName,
    vtdTunnelId,
    isStarted,
    clientId,
    clientName,
    thirdPartyClientTunnelId,
}) => (
    <div className='output-tunnel-popup'>
        <PopupTable
            rows={[
                {
                    header: 'VTD tunnel',
                    body: (
                        <span className='output-tunnel-popup__vtd'>
                            {`${vtdTunnelName ?? '-'} (${vtdTunnelId ?? '-'})`}
                            <TunnelStatus isStarted={!!isStarted} />
                        </span>
                    ),
                },
                {
                    header: 'Client',
                    body: renderClient(clientId, clientName),
                },
                {
                    header: '',
                    body: renderConfigurationLink(clientId, thirdPartyClientTunnelId),
                    hidden: !(clientId && thirdPartyClientTunnelId),
                },
            ]}
        />
    </div>
);

OutputTunnelPopupTable.propTypes = {
    vtdTunnelName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vtdTunnelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isStarted: PropTypes.bool,
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    clientName: PropTypes.string,
    thirdPartyClientTunnelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
